import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { canUseDOM } from '../../utils/execution-environment';

export interface PortalProps {
  children: ReactNode;
  target?: Element;
}

export function Portal({ children, target }: PortalProps) {
  if (!canUseDOM) return null;

  return createPortal(children, target || document.body);
}
